import type { AllRouteEndpoints } from "../routeTypes";

export const engagementReportDashboardDashboardId = "/engagement/report_dashboard/:dashboard_id";
export const engagementReportDashboardDashboardIdCacheKeys: AllRouteEndpoints[] = [];
